import * as PropTypes from "prop-types"
import { useLocale } from "react-polyglot-hooks"
import dynamic from "next/dynamic"

const PreOwned = dynamic(() => import("./PreOwned"))
const SpecialPromotion = dynamic(() => import("./SpecialPromotion"))
const Promotion = dynamic(() => import("./Promotion"))
const TestDrive = dynamic(() => import("./TestDrive"))
const OnlineScoring = dynamic(() => import("./OnlineScoring"))

function Promotions({ car, hideOnlineScoring }) {
  const {
    onlineScoring,
    sold,
    blueBackground,
    sellingStatus,
    specialPromotion,
    specialPromotionTitle,
    promotion,
    promotionTitle,
    testDrive,
    testDriveTitle
  } = car

  const locale = useLocale()

  if (sold) return null

  if (sellingStatus === "pre-owned" && locale === "es") return <PreOwned />

  if (specialPromotion && specialPromotionTitle)
    return (
      <SpecialPromotion>
        <span>{specialPromotionTitle}</span>
      </SpecialPromotion>
    )

  if (promotion && promotionTitle)
    return (
      <Promotion>
        <span>{promotionTitle}</span>
      </Promotion>
    )

  if (testDrive && testDriveTitle)
    return (
      <TestDrive>
        <span>{testDriveTitle}</span>
      </TestDrive>
    )

  if (onlineScoring && !hideOnlineScoring) return <OnlineScoring white={blueBackground} />

  return null
}

Promotions.defaultProps = {
  hideOnlineScoring: false
}

Promotions.propTypes = {
  car: PropTypes.object.isRequired,
  hideOnlineScoring: PropTypes.bool
}

export default Promotions
